// SimpleRadioButtons.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Radio } from 'antd';
import SimpleFormItem from './SimpleFormItem';
import useFormElement from 'hooks/useFormElement';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// FUNCTIONS
// *******************************************************************************
function $buildOptions() {
  return [
    { value: 1, label: 'option_1' },
    { value: 2, label: 'option_2' },
  ];
}

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleRadioButtons = ({ name, subdocumentField, options = $buildOptions(), ...props }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const elementProps = useFormElement(name, subdocumentField);
  const { elementRef, fullFieldName, flattenFieldName } = elementProps;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SimpleFormItem {...props} name={fullFieldName} elementProps={elementProps}>
      <Radio.Group
        ref={elementRef}
        id={flattenFieldName}
        options={options}
        optionType="button"
        buttonStyle="solid"
      />
    </SimpleFormItem>
  );
};

export default SimpleRadioButtons;
